import { createElement, useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

function Person({ m }) {
  return (
    <li data-testid={`org-person-${m.user_id}`}>
      {m.name}
      {m.role ? <span className="opacity-70"> · {m.role}</span> : null}
    </li>
  );
}

// Collapsible team tree. Children are rendered via createElement to avoid self-referencing JSX (dev tooling limitation).
export function OrgNode({ n, depth }) {
  const [open, setOpen] = useState(depth < 2);
  const has = n.children.length > 0 || n.members.length > 0;
  let chevron = <span className="inline-block w-3.5" />;
  if (has) chevron = open ? <ChevronDown className="h-3.5 w-3.5" /> : <ChevronRight className="h-3.5 w-3.5" />;
  const children = open ? n.children.map((c) => createElement(OrgNode, { key: c.team_id, n: c, depth: depth + 1 })) : null;
  return (
    <div className={depth ? "ml-5 border-l pl-3" : ""} data-testid={`org-node-${n.team_id}`}>
      <div className="flex items-center gap-2 py-1 text-sm">
        <button data-testid={`org-toggle-${n.team_id}`} className="text-muted-foreground" onClick={() => setOpen((o) => !o)} disabled={!has}>
          {chevron}
        </button>
        <span className="font-medium">{n.team}</span>
        {n.leader ? (
          <span className="text-xs text-muted-foreground">
            led by <b className="text-foreground">{n.leader.name}</b>
            {n.leader.role ? ` · ${n.leader.role}` : ""}
          </span>
        ) : null}
        <span className="ml-auto text-[10px] font-mono uppercase px-1.5 py-0.5 rounded bg-muted" data-testid={`org-headcount-${n.team_id}`}>
          {n.headcount} people
        </span>
      </div>
      {open && n.members.length > 0 ? (
        <ul className="ml-8 flex flex-wrap gap-x-4 gap-y-0.5 text-xs text-muted-foreground mb-1">
          {n.members.map((m) => <Person key={m.user_id} m={m} />)}
        </ul>
      ) : null}
      {children}
    </div>
  );
}
